import React from "react";
import { Box, FormControl, FormLabel } from "@chakra-ui/react";

type FieldWrapperProps = {
  field: any;
  invalid?: boolean;
  children: React.ReactNode;
};

export const FieldWrapper: React.FC<FieldWrapperProps> = ({ field, invalid, children }) => {
  return (
    <FormControl
      mb={4}
      isInvalid={!!invalid}
      data-field-name={field?.name}
      className={invalid ? "invalid" : ""}
    >
      <FormLabel>
        <b>{field?.label}</b>
        {field?.nullable !== true && <span style={{ color: "red" }}>*</span>}
      </FormLabel>

      <Box position="relative">
        {invalid && (
          <Box
            position="absolute"
            right="0"
            top="-8"
            bg="red.600"
            color="white"
            px="2"
            py="1"
            borderRadius="0"
            fontSize="xs"
            zIndex={1}
          >
            This field is required
            <Box
              position="absolute"
              left="50%"
              bottom="-6px"
              transform="translateX(-50%)"
              w="0"
              h="0"
              borderLeft="6px solid transparent"
              borderRight="6px solid transparent"
              borderTop="6px solid"
              borderTopColor="red.600"
            />
          </Box>
        )}

        {children}
      </Box>
    </FormControl>
  );
}
